// src/components/PackingLists/ProgressBar.js
import React from 'react';

/**
 * ProgressBar component displays the packing progress
 * 
 * @param {Object} props - Component props
 * @param {Array} props.items - List of packing items
 * @returns {JSX.Element} Rendered component
 */
const ProgressBar = ({ items }) => {
  const packedCount = items.filter(item => item.packed).length;
  const totalCount = items.length;
  const percentage = totalCount > 0 ? (packedCount / totalCount) * 100 : 0;
  
  let progressStatus = '';
  if (percentage === 100) progressStatus = 'complete';
  else if (percentage > 50) progressStatus = 'halfway';
  else progressStatus = 'starting';
  
  return (
    <div className={`card mb-3 border-0 shadow-sm ${
        progressStatus === 'complete' ? 'border-start border-success border-4' : 
        progressStatus === 'halfway' ? 'border-start border-warning border-4' : 
        'border-start border-danger border-4'
      }`} 
      style={{ borderRadius: "8px" }}
    >
      <div className="card-body text-center py-2">
        <div className="d-flex flex-column align-items-center">
          <div className="mb-2">
            <span className="fs-5">
              <strong className={
                progressStatus === 'complete' ? 'text-success' : 
                progressStatus === 'halfway' ? 'text-warning' : 
                'text-danger'
              }>{packedCount}</strong> of <strong className={
                progressStatus === 'complete' ? 'text-success' : 
                progressStatus === 'halfway' ? 'text-warning' : 
                'text-danger'
              }>{totalCount}</strong> items packed
            </span>
          </div>
          {totalCount > 0 && (
            <div className="progress w-100" style={{ maxWidth: "300px", height: "8px", borderRadius: "4px" }}>
              <div 
                className={`progress-bar ${
                  progressStatus === 'complete' ? 'bg-success' : 
                  progressStatus === 'halfway' ? 'bg-warning' : 
                  'bg-danger'
                }`}
                role="progressbar"
                style={{ 
                  width: `${percentage}%`,
                  transition: "width 0.3s ease, background-color 0.3s ease"
                }}
                aria-valuenow={percentage}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;